// src/utils/platform.js

export const getPlatform = () => {
  // 1. Check if Cordova's global variable exists
  const isCordova = !!window.cordova;

  // 2. Check the User Agent for specific OS details
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  if (isCordova) {
    if (isAndroid) return 'cordova-android';
    if (isIOS) return 'cordova-ios';
    return 'cordova';
  }

  return 'web';
};

export const isApp = getPlatform().startsWith('cordova');
export const isWeb = getPlatform() === 'web';